export default __webpack_public_path__ + "media/images/images/elements/12-6d43d2eab68c4032e45a63296e7d2293.png";